<page-title title="Configuracoes de Pagamento"></page-title>

<div class="bank-details-container">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <mat-card class="recipient-status-card">
    <div class="recipient-status-header">
      <div>
        <span class="recipient-status-eyebrow">Status Pagar.me</span>
        <h3>Cadastro como recebedor</h3>
      </div>
      <span class="recipient-status-badge" [ngClass]="recipientStatus.code">{{ recipientStatus.label }}</span>
    </div>

    <p class="recipient-status-description">{{ recipientStatus.description }}</p>

    <div class="recipient-status-grid">
      <div class="recipient-status-item">
        <span>Recebedor</span>
        <strong>{{ recipientStatus.recipientLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Validacao</span>
        <strong>{{ recipientStatus.kycLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Conta bancaria</span>
        <strong>{{ recipientStatus.bankAccountLabel }}</strong>
      </div>
      <div class="recipient-status-item">
        <span>Cadastro Pagar.me</span>
        <strong>{{ recipientStatus.onboardingLabel }}</strong>
      </div>
    </div>

    <div class="recipient-status-next-step">{{ recipientStatus.nextStep }}</div>
  </mat-card>

  <mat-card>
    <form [formGroup]="bankDetailsForm">
      <div class="row">
        <div class="col-xs-12">
          <h3>Dados Bancarios</h3>
        </div>

        <div class="col-xs-12 col-sm-6">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Nome do Titular</mat-label>
            <input matInput formControlName="holder_name" placeholder="Digite o nome completo do titular" />
            <mat-error *ngIf="holderName?.hasError('required')">O nome do titular e obrigatorio.</mat-error>
            <mat-error *ngIf="holderName?.hasError('minlength')">Informe pelo menos 3 caracteres.</mat-error>
            <mat-error *ngIf="holderName?.hasError('maxlength')">
              Nome do titular deve ter no maximo 30 caracteres e deve ser o nome no cartao relacionado a esta conta.
            </mat-error>
            <mat-error *ngIf="holderName?.hasError('pattern')">Informe um nome valido.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-6">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Banco</mat-label>
            <input
              type="text"
              matInput
              formControlName="bank_search"
              [matAutocomplete]="bankAuto"
              placeholder="Digite o nome ou codigo do banco"
              (input)="onBankInputChanged()"
              (blur)="trySelectTypedBank()"
            />
            <mat-autocomplete #bankAuto="matAutocomplete" [displayWith]="displayBank" (optionSelected)="onBankSelected($event)">
              <mat-option *ngFor="let bank of filteredBanks$ | async" [value]="bank">
                {{ formatBankCode(bank.code) }} - {{ bank.fullName || bank.name }}
              </mat-option>
            </mat-autocomplete>
            <mat-error
              *ngIf="
                bankSearch?.hasError('required') ||
                bankDetailsForm.get('bank')?.hasError('required') ||
                bankDetailsForm.get('bank_number')?.hasError('required')
              "
            >
              Selecione um banco valido.
            </mat-error>
          </mat-form-field>
          <input type="hidden" formControlName="bank" />
          <input type="hidden" formControlName="bank_number" />
        </div>

        <div class="col-xs-12 col-sm-6">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tipo de Pessoa</mat-label>
            <mat-select formControlName="holder_type">
              <mat-option value="individual">Pessoa Fisica</mat-option>
              <mat-option value="company">Pessoa Juridica</mat-option>
            </mat-select>
            <mat-error *ngIf="bankDetailsForm.get('holder_type')?.hasError('required')">O tipo de pessoa e obrigatorio.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-6">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Documento do Titular</mat-label>
            <input matInput formControlName="holder_document" [mask]="documentMask" [placeholder]="documentPlaceholder" />
            <mat-error *ngIf="documentControl?.hasError('required')">O documento e obrigatorio.</mat-error>
            <mat-error *ngIf="documentControl?.hasError('cpfInvalid')">CPF invalido.</mat-error>
            <mat-error *ngIf="documentControl?.hasError('cnpjInvalid')">CNPJ invalido.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-4">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Agencia</mat-label>
            <input matInput formControlName="branch_number" placeholder="Ex: 1234" maxlength="5" />
            <mat-error *ngIf="bankDetailsForm.get('branch_number')?.hasError('required')">O numero da agencia e obrigatorio.</mat-error>
            <mat-error *ngIf="bankDetailsForm.get('branch_number')?.hasError('pattern')">Informe apenas numeros, de 1 a 5 digitos.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-2">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Digito agencia</mat-label>
            <input matInput formControlName="branch_check_digit" maxlength="1" placeholder="Ex: 0" (blur)="onBranchCheckDigitBlur()" />
            <mat-error *ngIf="bankDetailsForm.get('branch_check_digit')?.hasError('pattern')">Informe um inteiro maior ou igual a 0.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-4">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Numero da Conta</mat-label>
            <input matInput formControlName="account_number" maxlength="13" placeholder="Ex: 123456" />
            <mat-error *ngIf="accountNumber?.hasError('required')">O numero da conta e obrigatorio.</mat-error>
            <mat-error *ngIf="accountNumber?.hasError('pattern')">Informe apenas numeros, de 4 a 13 digitos.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-2">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Digito conta</mat-label>
            <input matInput formControlName="account_check_digit" maxlength="1" placeholder="Ex: 7" />
            <mat-error *ngIf="accountDigit?.hasError('required')">O digito da conta e obrigatorio.</mat-error>
            <mat-error *ngIf="accountDigit?.hasError('pattern')">Informe 1 digito ou X.</mat-error>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-4">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Tipo de Conta</mat-label>
            <mat-select formControlName="type">
              <mat-option value="checking">Conta Corrente</mat-option>
              <mat-option value="savings">Conta Poupanca</mat-option>
            </mat-select>
            <mat-error *ngIf="bankDetailsForm.get('type')?.hasError('required')">O tipo de conta e obrigatorio.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <h3>Configuracoes de Transferencias</h3>
        </div>

        <div class="col-xs-12 col-sm-6">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Recorrencia de Transferencia</mat-label>
            <mat-select formControlName="transfer_interval">
              <mat-option value="daily">Diario</mat-option>
              <mat-option value="weekly">Semanal</mat-option>
              <mat-option value="monthly">Mensal</mat-option>
            </mat-select>
            <mat-error *ngIf="bankDetailsForm.get('transfer_interval')?.hasError('required')"
              >A recorrencia de transferencia e obrigatoria.</mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-sm-6" *ngIf="showTransferDay">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ transferDayLabel }}</mat-label>
            <mat-select formControlName="transfer_day">
              <mat-option *ngFor="let day of transferDays" [value]="day.value">{{ day.label }}</mat-option>
            </mat-select>
            <mat-error *ngIf="bankDetailsForm.get('transfer_day')?.hasError('required')">O dia de recebimento e obrigatorio.</mat-error>
            <mat-error *ngIf="bankDetailsForm.get('transfer_day')?.hasError('min') || bankDetailsForm.get('transfer_day')?.hasError('max')">
              {{ transferDayErrorMessage }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card>

  <div class="actions" align="end">
    <button mat-stroked-button color="primary" type="button" (click)="openOrCreateOnboarding()" [disabled]="loading || !canOpenOnboarding">
      {{ onboardingButtonLabel }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="createOrUpdateSettings()" [disabled]="loading || bankDetailsForm.invalid">
      <ng-container *ngIf="!loading">Salvar</ng-container>
      <ng-container *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </ng-container>
    </button>
  </div>
</div>
